import { useCityStore } from '~/stores/city'

export default defineNuxtPlugin(async () => {
  const cityStore = useCityStore()

  if (import.meta.server) {
    await cityStore.hydrateFromRoute()

    return
  }

  onNuxtReady(() => {
    void (async () => {
      await cityStore.syncFromLocalStorage()
      await cityStore.init()
    })()
  })
})
